import {
  Card,
  CardActionArea,
  CardContent,
  Checkbox,
  Grid,
  Typography,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import { TargetedCheckInsContext } from "contexts/TargetedCheckIns";
import { useContext } from "react";
import { ActionItem } from "schemas/dashboard";
import { CustomEvent } from "schemas/functions";

import styles from "./styles";

interface Props {
  actionItem: ActionItem;
  selectedIds: number[];
  selectItem: (actionItem: ActionItem) => void;
  clickOnActionItem: (actionItem: ActionItem) => void;
}

const PreviewCard = ({
  actionItem,
  selectedIds,
  selectItem,
  clickOnActionItem,
}: Props) => {
  const { actionItem: selectedActionItem } = useContext(
    TargetedCheckInsContext,
  );

  return (
    <Card key={actionItem.id} elevation={0}>
      <CardActionArea
        onClick={() => clickOnActionItem(actionItem)}
        sx={[
          {
            height: "100%",
          },
          selectedActionItem?.id === actionItem.id
            ? { backgroundColor: "#f0f2ee" }
            : {},
        ]}
      >
        <CardContent sx={styles.section}>
          <Grid container alignItems="center">
            <Checkbox
              checked={selectedIds?.includes(actionItem.id)}
              sx={{ ml: -1 }}
              onClick={(e) => e.stopPropagation()}
              onChange={(e: CustomEvent) => {
                selectItem(actionItem);
              }}
              size="small"
            />
            <Typography sx={{ color: "primary.main" }}>
              <strong>{actionItem?.brandName}</strong>
            </Typography>
          </Grid>

          <Typography sx={{ fontSize: { xs: 11, md: 13 } }}>
            <strong>{actionItem?.subject}</strong>
          </Typography>

          <Typography sx={{ color: grey[500], fontSize: { xs: 10, md: 12 } }}>
            {actionItem?.description}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default PreviewCard;
